import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'role/admin', method: 'GET', body: null, token: token })
}
